module.exports = __webpack_public_path__ + "img/embedded.79caa600.png";